export const advertismentHeader = [
  {
    id: 1,
    blogImage: require("../assets/blog-image.png"),
    blogTitle:
      "ADS Effective Strategies for Creating Diverse and Captivating Content.",
    blogDate: "March 24, 2024",
  },
];

export const advertisment = [
  {
    id: 1,
    blogImage: require("../assets/blog-3.jpg"),
    blogTitle:
      "Effective Strategies for Creating Diverse and Captivating Content.",
    blogDate: "March 24, 2024",
  },
  {
    id: 2,
    blogImage: require("../assets/blog-image-2.jpg"),
    blogTitle: "Top SEO Strategies for 2024 to Boost Your Traffic.",
    blogDate: "March 24, 2024",
  },
  {
    id: 3,
    blogImage: require("../assets/blog-3.jpg"),
    blogTitle: "10 Tips for Writing Clean, Maintainable Code.",
    blogDate: "March 24, 2024",
  },
  {
    id: 4,
    blogImage: require("../assets/blog-4.jpg"),
    blogTitle:
      "Mastering Video Editing: Tips and Tools to Elevate Your Visual Content.",
    blogDate: "March 24, 2024",
  },
  {
    id: 5,
    blogImage: require("../assets/blog-5.jpg"),
    blogTitle:
      "How to Use SEO Tools to Analyze and Improve Your Website’s Performance.",
    blogDate: "March 24, 2024",
  },
  {
    id: 6,
    blogImage: require("../assets/blog-7.jpg"),
    blogTitle:
      "How Great UI/UX Design Can Transform Your Business's Online Presence.",
    blogDate: "March 24, 2024",
  },
  {
    id: 7,
    blogImage: require("../assets/blog-image-2.jpg"),
    blogTitle:
      "UI/UX Design Basics: Creating User-Centered Digital Experiences.",
    blogDate: "March 24, 2024",
  },
  {
    id: 8,
    blogImage: require("../assets/blog-4.jpg"),
    blogTitle:
      "How Great UI/UX Design Can Transform Your Business's Online Presence.",
    blogDate: "March 24, 2024",
  },
  {
    id: 9,
    blogImage: require("../assets/blog-image-2.jpg"),
    blogTitle:
      "UI/UX Design Basics: Creating User-Centered Digital Experiences.",
    blogDate: "March 24, 2024",
  },
];
